/* eslint-disable */
import {extendDecorator, viewModelDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import { isEmiratesAvailable } from '@features/tourProduct/filterTourProducts';
import './style.scss';
import template from './template.html';

@viewModelDecorator({
    block: false,
})
@extendDecorator({
    template,
    bindings: {
        label: 'classes:{checked:block}',
        input: 'checked:block',
    },
})


export default class EmiratesView extends Backbone.Epoxy.View {
    initialize(options) {
        this.searchPageModel = options.searchPageModel;
        this.initModelEvents();
        this.render();
    }

    checkEmiratesVisible() {
        const departureCity = this.searchPageModel.get('searchData')?.get('departureCity')?.attributes;
        const country = this.searchPageModel.get('searchData')?.get('countries')?.at(0)?.attributes;
        const isVisible = isEmiratesAvailable(departureCity, country);
        if(isVisible) {
            document.querySelector('.serp-emirates-filter').classList.add('serp-emirates-filter_open');
        } else {
            document.querySelector('.serp-emirates-filter').classList.remove('serp-emirates-filter_open');
        }
    }

    initModelEvents() {
        this.checkEmiratesVisible();
        this.searchPageModel.on('change:searchData', this.checkEmiratesVisible.bind(this));

        this.viewModel.mapState({
            block: 'model',
        }, this.model);     

        this.viewModel.on('change:block', (model, value) => {
            this.model.set({
                model: value,
            }, { initiator: 'view' });
        });
    }

    render() {
        console.log(this.$el);
        this.$el.html(template());
    }
}